module.exports = __webpack_public_path__ + "img/upload.c62065e9.svg";